<template>
    
  <div>

    <ttbox-regle :regle="regle" v-for="regle in regles" :key="regle.idRegle" @change="refresh" />

    <ttbox-regle :nouvelleRegle="true" @change="refresh" />

  </div>

</template>

<script>
import Regle from '../components/Regle'

export default {
    components: {
        'ttbox-regle': Regle
    },
    created () {
        this.refresh()
    },
    methods: {
        refresh() {
            this.$store.dispatch('lireRegles')
        }
    },
    computed:{
        regles() {
            return this.$store.state.regles;
        }
    }
}
</script>

<style scoped>

</style>
